import { StatusToast, StatusToastProps } from './StatusToast';

export function renderStatusToast(props: Readonly<StatusToastProps>) {
  return <StatusToast {...props} />;
}
